import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";


export const EmojiBackground = ({ numEmoji = 12, emojiChars = ["❤️", "💖", "💕", "🐶", "🐾", "🐰"] }) => {
  const generateEmoji = (numEmoji) => {
    return Array.from({ length: numEmoji }).map((_, index) => ({
      id: index,
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      duration: Math.random() * 5 + 20,
      delay: Math.random() * 10,
    }));
  };

  const [emojis, setEmojis] = useState(() => generateEmoji(numEmoji));

  useEffect(() => {
    const handleResize = () => setEmojis(generateEmoji(numEmoji));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        pointerEvents: "none",
        zIndex: 0,
      }}
    >
      {emojis.map((emoji, index) => (
        <motion.div
          key={emoji.id}
          initial={{ opacity: 0, y: emoji.y, x: emoji.x }}
          animate={{ opacity: [0, 0.5, 0], y: [emoji.y, -100], x: [emoji.x, emoji.x + Math.random() * 100 - 50] }}
          transition={{ duration: emoji.duration, delay: emoji.delay, repeat: Infinity }}
          style={{
            position: "absolute",
            fontSize: "2rem",
          }}
        >
          {emojiChars[index % emojiChars.length]}
        </motion.div>
      ))}
    </Box>
  );
}
